import checkVentory from "./checkVentory";
import uVerify from "./uVerify";

const envs = {
    // checkVentory env configs
    "local-cv": checkVentory.local,
    "dev-cv": checkVentory.dev,
    "qa-cv": checkVentory.qa,
    "prod-cv": checkVentory.prod,
    // uVerify env configs
    "local-uv": uVerify.local,
    "staging-uv": uVerify.staging,
    "prod-uv": uVerify.prod,
};

export default envs;
